/** packages/shared-components/src/components/KeyRemappingPanel/KeyRemappingPanel.tsx */

import React from "react";
import { useTranslation } from "react-i18next"; // 重新引入
import { KeyboardLayoutSelector } from "../KeyboardLayoutSelector";
import "./KeyRemappingPanel.css";

export interface KeyRemappingPanelProps {
  props?: Record<string, any>;
  /** 选择器选择回调 */
  onSelectorSelect?: (keyCode: number) => void;
  /** 自定义类名 */
  className?: string;
  /** 当前活动类别 */
  activeCategory: string;
  /** 设置活动类别的方法 */
  setActiveCategory: (category: string) => void;
  /** 禁用的 keyCode 列表（如未配置指令的宏），这些按键不可拖拽/点击 */
  disabledKeyCodes?: number[];
  /** 下方按键是否可拖拽到上方虚拟键盘改键 */
  draggable?: boolean;
  /** 用于KeyboardLayoutContent的键盘骨架屏兜底 */
  layoutLoading?: boolean;
}

export const KeyRemappingPanel: React.FC<KeyRemappingPanelProps> = ({
  onSelectorSelect,
  activeCategory,
  setActiveCategory,
  className,
  disabledKeyCodes,
  draggable = true,
  layoutLoading,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`key-remapping-panel ${className || ""}`}>
      {/* 标题区域 */}
      <div className="key-remapping-header">
        <h3 className="key-remapping-title">{t("keyboard.changeKey.title")}</h3>
        <p className="key-remapping-description">
          {t("keyboard.changeKey.description")}
        </p>
      </div>

      {/* 按键选择器 */}
      <div className="key-remapping-panel-selector">
        <KeyboardLayoutSelector
          onSelect={onSelectorSelect}
          // 传递活动分类及其更新方法
          activeCategory={activeCategory}
          setActiveCategory={setActiveCategory}
          disabledKeyCodes={disabledKeyCodes}
          draggable={draggable}
          layoutLoading={layoutLoading}
        />
      </div>
    </div>
  );
};
